<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="'首页'"></navBox>
			<!--导航-->
			<!--banner-->
			<div v-if="bannerList.length > 0" class="banner_box">
				<div class="icon_left animate__animated animate__fadeInLeft" @click="bannerLeftClick">
					<van-icon name="arrow-left" color="#ffffff" size="20px" />
				</div>
				<div class="icon_right animate__animated animate__fadeInRight" @click="bannerRightClick">
					<van-icon name="arrow" color="#ffffff" size="20px" />
				</div>
				<van-swipe
					ref="swipeBox"
					class="swipe_box"
					:autoplay="5000"
					:show-indicators="true"
					:stop-propagation="false"
					lazy-render
					indicator-color="#C8000A"
				>
					<van-swipe-item
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						v-for="(value, index) in bannerList"
						:key="index"
						@click.stop="goBannerInfo(value)"
					>
						<div class="swiper_el">
							<img class="bg" :src="webUrl + value.image" />
						</div>
					</van-swipe-item>
				</van-swipe>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="top_box"
					>
						<div class="left">
							<div class="title_box">
								<div class="left_tit">
									<div class="tit_en">About Abiores</div>
									<div class="tit_cn">关于宝瑞源</div>
								</div>
								<div class="right_tit">科技创新园</div>
							</div>
						</div>
						<div class="right">
							<div class="num_box">
								<count-to :startVal="0" :endVal="60" :duration="5000" class="num"></count-to>
								<div class="icon_1">+</div>
								<div class="icon_2">亩</div>
							</div>
							<div class="num_box">
								<count-to :startVal="0" :endVal="3" :duration="3000" class="num"></count-to>
								<span style="position: relative;left: -12px;">W</span>
								<div class="icon_1" style="right: -13px;">+</div>
								<div class="icon_2" style="right: -13px;">㎡</div>
							</div>
						</div>
					</div>
					<div class="list_box">
						<div
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							class="left"
						>
							<img src="../../assets/img_public/index/block1.webp" />
						</div>
						<div class="right">
							<div class="right_main">
								<div
									data-aos="fade-up"
									data-aos-duration="400"
									data-aos-delay="200"
									data-aos-offset="0"
									data-aos-once="true"
									class="tit"
								>
									专业从事体外诊断试剂的研发、生产、销售和技术服务
								</div>
								<div
									data-aos="fade-up"
									data-aos-duration="400"
									data-aos-delay="400"
									data-aos-offset="0"
									data-aos-once="true"
									class="txt"
								>
									宝瑞源生物技术（北京）有限公司成立于2010年，为美国 Cordx Union 集团旗下的子公司，是中关村高新技术企业、北京市高新技术企业、“专精特新”企业。公司专注于分子诊断平台的构建与优化，集研发、生产、营销于一体，致力于为全球提供实惠、精准、易用的诊断产品。
								</div>
								<div
									data-aos="fade-up"
									data-aos-duration="400"
									data-aos-delay="400"
									data-aos-offset="0"
									data-aos-once="true"
									class="txt">
									目前宝瑞源生物已拥有磁珠法、一管法、自动化核酸提取等技术平台，开发了多种病原体精准定量、准确分型的系列核酸检测试剂盒，服务于各级医院系统、疾控中心、第三方检验实验室等医疗机构。
								</div>
								<div
									data-aos="fade-up"
									data-aos-duration="400"
									data-aos-delay="400"
									data-aos-offset="0"
									data-aos-once="true"
									class="txt">
									宝瑞源生物将持续以“安全有效 使命必达”为宗旨，运用现代生物工程技术和医学研究成果，打造超一流医药企业，为全球健康事业服务！
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main">
					<div class="top_box">
						<div class="left">
							<div
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
								class="title_box"
							>
								<div class="left_tit">
									<div class="tit_en">Solution</div>
									<div class="tit_cn">解决方案</div>
								</div>
								<div class="right_tit">宝瑞源为您提供专业、多样化的解决方案</div>
							</div>
						</div>
						<!-- <div class="right">
							<div class="line_box">
								<div :class="isSolution == 0 ? 'actived' : ''"></div>
								<div :class="isSolution == 1 ? 'actived' : ''"></div>
								<div :class="isSolution == 2 ? 'actived' : ''"></div>
							</div>
						</div> -->
					</div>
					<div
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="list_box"
						v-if="solutionList.length > 0"
					>
						<div v-for="(value, index) in solutionList" :key="index"  class="list_el" @click="goProduct(1, value)">
							<img :src="webUrl + value.thumb_active" />
							<div
								data-aos="fade-left"
								data-aos-duration="400"
								data-aos-delay="0"
								data-aos-offset="0"
								data-aos-once="true"
								class="msg_box"
							>
								<img class="bg" :src="webUrl + value.icon_active" />
								<div class="tit">{{ value.title }}</div>
								<div class="tit_en">{{ value.en_title }}</div>
								<div class="icon">
									<van-icon name="arrow" size="18px" />
								</div>
							</div>
						</div>
						<!-- <ul v-if="solutionList.length > 0" class="list_box_main">
							<li
								v-for="(value, index) in solutionList"
								:key="index" 
								:class="isSolution == index ? 'current active' : ''"
								@click="goProduct(1, value)"
							>
								<img class="small" :src="webUrl + value.thumb" width="25%">
								<img class="big" :src="webUrl + value.thumb_active" width="50%">
								<div
									data-aos="fade-left"
									data-aos-duration="400"
									data-aos-delay="0"
									data-aos-offset="0"
									data-aos-once="true"
									v-if="isSolution == index"
									class="msg_box"
								>
									<img class="bg" :src="webUrl + value.icon_active" />
									<div class="tit">{{ value.title }}</div>
									<div class="tit_en">{{ value.en_title }}</div>
									<div class="icon">
										<van-icon name="arrow" size="18px" />
									</div>
								</div>
							</li>
						</ul> -->
					</div>
					<div class="bottom_box">
						<div class="left">
							<div class="left_main">
								<div
									data-aos="fade-up"
									data-aos-duration="400"
									data-aos-delay="200"
									data-aos-offset="0"
									data-aos-once="true"
									class="tit_en"
								>Our Services</div>
								<div
									data-aos="fade-up"
									data-aos-duration="400"
									data-aos-delay="300"
									data-aos-offset="0"
									data-aos-once="true"
									class="tit"
								>我们为医药同行提供优质服务</div>
								<div
									data-aos="fade-up"
									data-aos-duration="400"
									data-aos-delay="400"
									data-aos-offset="0"
									data-aos-once="true"
									class="txt"
								>医疗器械  &  诊断试剂</div>
							</div>
						</div>
						<div
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							class="right"
						>
							<img src="../../assets/img_public/index/block4.webp" />
							<!-- <div class="msg_box">
								<div class="num_box" style="right: 100px;">
									<count-to :startVal="0" :endVal="170" :duration="5000" class="num"></count-to>
									<div class="icon_1">+</div>
									<div class="icon_2" style="right: -95px;">销往国家地区</div>
								</div>
								<div class="num_box" style="left: 100px;">
									<count-to :startVal="0" :endVal="1" :duration="5000" class="num"></count-to>
									<div class="icon_1">+</div>
									<div class="icon_2" style="right: -55px;">亿用户</div>
								</div>
							</div> -->
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="block_3_main">
					<div class="top_box">
						<div
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							class="left"
						>
							<div class="title_box">
								<div class="left_tit">
									<div class="tit_en">Our Products</div>
									<div class="tit_cn">我们的产品</div>
								</div>
								<div class="right_tit">多种体外检测产品供您选择</div>
							</div>
						</div>
					</div>
					<div class="list_box">
						<div v-if="productTypeList.length > 0" class="top_list">
						<template v-for="(value, index) in productTypeList">
							<div
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
								v-if="index <= 1"
								:key="index"
								class="list_el"
								@click="goProduct(2, value)"
							>
								<img class="bg" :src="webUrl + value.thumb" />
								<div
									data-aos="fade-left"
									data-aos-duration="400"
									data-aos-delay="300"
									data-aos-offset="0"
									data-aos-once="true"
									class="msg_box"
								>
									<img :src="webUrl + value.icon_active" />
									<div class="tit_box">
										<div class="tit">{{ value.title }}</div>
										<div class="tit_en">{{ value.en_title }}</div>
									</div>
								</div>
							</div>
						</template>
						</div>
						<div class="bot_list">
							<template v-for="(value, index) in productTypeList">
								<div
									data-aos="fade-in"
									data-aos-duration="400"
									data-aos-delay="100"
									data-aos-offset="0"
									data-aos-once="true"
									v-if="index > 1 && value.title != '解决方案'"
									:key="index"
									class="list_el"
									@click="goProduct(2, value)"
								>
									<img class="bg" :src="webUrl + value.thumb" />
									<div
										data-aos="fade-left"
										data-aos-duration="400"
										data-aos-delay="300"
										data-aos-offset="0"
										data-aos-once="true"
										class="msg_box"
									>
										<img :src="webUrl + value.icon_active" />
										<div class="tit_box">
											<div class="tit">{{ value.title }}</div>
											<div class="tit_en">{{ value.en_title }}</div>
										</div>
									</div>
								</div>
							</template>
						</div>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<div class="block_4_main">
					<div class="top_box">
						<div
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							class="left"
						>
							<div class="title_box">
								<div class="left_tit">
									<div class="tit_en">Culture & Honors</div>
									<div class="tit_cn">文化与资质</div>
								</div>
								<div class="right_tit" style="margin-left: 0;">一起改变全球诊断</div>
							</div>
						</div>
					</div>
					<div class="list_box">
						<div class="list_el" @click="goCulture">
							<img
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
								src="../../assets/img_public/index/block2.webp"
							>
							<div
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="300"
								data-aos-offset="0"
								data-aos-once="true"
								class="msg_box"
							>
								<div class="tit">企业文化</div>
								<div class="tit_en">Corporate Culture</div>
								<div class="icon">
									<van-icon name="arrow" size="18px" />
								</div>
							</div>
						</div>
						<div class="list_el" @click="goHonor">
							<img
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
								src="../../assets/img_public/index/block3.webp"
							>
							<div
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="300"
								data-aos-offset="0"
								data-aos-once="true"
								class="msg_box"
							>
								<div class="tit">荣誉资质</div>
								<div class="tit_en">Honors And Qualifications</div>
								<div class="icon">
									<van-icon name="arrow" size="18px" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5">
				<div class="block_5_main">
					<contact></contact>
				</div>
			</div>
			<!--块5-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import contact from '@/component/pc/contact.vue'  //联系我们组件
import CountTo from 'vue-count-to'
import { UPURL } from '@/util/util';
import $ from 'jquery'
export default {
	components:{
		navBox,
		footerBox,
		contact,
		CountTo
	},
	data() {
		return {
			isLoading: true,  //界面loading
			bannerList: [],
			solutionList: [],  //解决方案列表
			isSolution: 0,  //解决方案选中索引
			productTypeList: [],  //产品分类列表1
			webUrl: UPURL,
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navList')) {
			that.solutionList = JSON.parse(sessionStorage.getItem('navList'))[1].children.scenarios_list;
			that.productTypeList = JSON.parse(sessionStorage.getItem('navList'))[1].children.cate_list;
		}
	},
	mounted() {
		let that = this;
		if(sessionStorage.getItem('bannerList')) {
			let bannerData = JSON.parse(sessionStorage.getItem('bannerList'));
			bannerData.forEach((value, index) => {
				if(value.leixing == 1) {
					that.bannerList.push(value);
				}
			});
			that.isLoading = false;
			that.$nextTick(() => {
				setTimeout(() => {
					//调用解决方案动画
					that.initSolution();
				}, 500);
			});
		}
	},
	watch: {
		//
	},
	methods: {
		//点击查看轮播图详情
		goBannerInfo(value) {
			if(value.url) {
				window.open(value.url);
			}
		},
		bannerLeftClick() {  //导航左侧按钮点击
			let that = this;
			that.$refs.swipeBox.prev();
		},
		bannerRightClick() {  //导航右侧按钮点击
			let that = this;
			that.$refs.swipeBox.next();
		},
		//点击进入产品
		goProduct(type, value) {
			let that = this;
			switch(type) {
				case 1:
					that.$router.push({ path: '/product.html', query: { scenarios_ids: value.id } });
				break;
				case 2:
					that.$router.push({ path: '/product.html', query: { cate_ids: value.id } });
				break;
			}
		},
		//跳转企业文化
		goCulture() {
			let that = this;
			that.$router.push({ path: '/about/culture.html' });
		},
		//跳转荣誉资质
		goHonor() {
			let that = this;
			that.$router.push({ path: '/about/honor.html' });
		},
		//解决方案动画
		initSolution() {
			let that = this;
			$('.list_box_main li').mouseenter(function(){
				if(that.isSolution != $(this).index()) {
					that.isSolution = null;
					$(this).siblings('li').stop().animate({
						width: '25%',
					},400).find('.small').stop().fadeIn().siblings('.big').stop().fadeOut();
					$(this).stop().animate({
						width: '50%',
					},400).find('.small').stop().fadeOut().siblings('.big').stop().fadeIn();
					setTimeout(() => {
						that.isSolution = $(this).index();
					}, 500);
				}
			});
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	//块5
	.block_5{
		padding: 100px 0 150px 0;
		.block_5_main{
			width: 80%;
			min-width: 1200px;
			margin: 0 auto;
		}
	}
	//块4
	.block_4{
		.block_4_main{
			.list_box{
				display: flex;
				width: 80%;
				min-width: 1200px;
				// width: 1200px;
				margin: 0 auto;
				.list_el:first-child{
					margin-right: 5px;
				}
				.list_el:last-child{
					margin-left: 5px;
				}
				.list_el:hover{
					img{
						transform: scale(1.2);
					}
				}
				.list_el{
					flex: 1;
					position: relative;
					cursor: pointer;
					overflow: hidden;
					.msg_box{
						position: absolute;
						z-index: 1;
						left: 60px;
						bottom: 60px;
						.icon{
							margin-top: 30px;
							width: 30px;
							height: 30px;
							padding-top: 6px;
							text-align: center;
							display: inline-block;
							background-color: #ABA2A2;
							border-radius: 50%;
						}
						.tit_en{
							font-size: 24px;
							color: #ffffff;
						}
						.tit{
							padding: 15px 0 5px 0;
							font-size: 30px;
							font-weight: bold;
							color: #ffffff;
						}
					}
					img{
						width: 100%;
						transition: all 0.6s;
					}
				}
			}
			.top_box{
				display: flex;
				align-items: end;
				width: 80%;
				min-width: 1200px;
				margin: 0 auto;
				padding: 100px 0 60px 0;
				.left{
					flex: 1;
				}
			}
		}
	}
	//块3
	.block_3{
		.block_3_main{
			.list_box{
				width: 100%;
				min-width: 1200px;
				.top_list, .bot_list{
					display: flex;
					.list_el:first-child{
						margin-left: 0;
					}
					.list_el:last-child{
						margin-right: 0;
					}
					.list_el:hover{
						img.bg{
							transform: scale(1.2);
						}
					}
					.list_el{
						flex: 1;
						position: relative;
						margin: 5px 5px 5px 5px;
						cursor: pointer;
						overflow: hidden;
						.msg_box{
							position: absolute;
							z-index: 1;
							left: 50px;
							bottom: 50px;
							display: flex;
							align-items: center;
							.tit_box{
								padding-left: 26px;
								.tit_en{
									font-size: 24px;
								}
								.tit{
									font-size: 30px;
								}
							}
							img{
								width: 80px;
								object-fit: contain;
							}
						}
						img.bg{
							width: 100%;
							height: 100%;
							object-fit: cover;
							transition: all 0.6s;
						}
					}
				}
			}
			.top_box{
				display: flex;
				align-items: end;
				width: 80%;
				min-width: 1200px;
				margin: 0 auto;
				padding: 100px 0 60px 0;
				.left{
					flex: 1;
				}
			}
		}
	}
	//块2
	.block_2{
		.block_2_main{
			.list_box{
				display: flex;
				width: 80%;
				margin: 0 auto;
				.list_el{
					flex: 1;
					margin: 0 8px;
					position: relative;	
					cursor: pointer;
					img{
						width: 100%;
					}
					.msg_box{
						position: absolute;
						z-index: 1;
						left: 10%;
						bottom: 5%;
						.icon{
							margin-top: 20px;
							width: 30px;
							height: 30px;
							padding-top: 6px;
							text-align: center;
							display: inline-block;
							background-color: #F4F3F3;
							border-radius: 50%;
						}
						.tit_en{
							font-size: 18px;
						}
						.tit{
							padding: 15px 0 5px 0;
							font-size: 20px;
							font-weight: bold;
						}
						.bg{
							width: 60px;
							height: 60px;
						}
					}
				}
			}
			.bottom_box{
				display: flex;
				width: 100%;
				min-width: 1200px;
				margin-top: 100px;
				.right{
					flex: 1;
					position: relative;
					.msg_box{
						position: absolute;
						left: 50%;
						top: 50%;
						z-index: 1;
						transform: translate(-50%, -50%);
						.num_box{
							display: table-cell;
						}
					}
					img{
						width: 100%;
					}
				}
				.left{
					flex: 1;
					position: relative;
					background-color: #C8000A;
					.left_main{
						width: 80%;
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						.txt{
							padding-top: 10px;
							font-size: 24px;
							color: #ffffff;
						}
						.tit{
							font-size: 44px;
							color: #ffffff;
						}
						.tit_en{
							font-size: 70px;
							color: #ffffff;
						}
					}
				}
			}
			// .list_box{
			// 	ul{
			// 		display: flex;
			// 		width: 80%;
			// 		margin: 0 auto;
			// 		overflow: hidden;
			// 		li{
			// 			position: relative;
			// 			width: 25%;
			// 			margin: 0 5px;
			// 			cursor: pointer;
			// 			.msg_box{
			// 				position: absolute;
			// 				z-index: 1;
			// 				left: 80px;
			// 				bottom: 80px;
			// 				.icon{
			// 					margin-top: 30px;
			// 					width: 30px;
			// 					height: 30px;
			// 					padding-top: 6px;
			// 					text-align: center;
			// 					display: inline-block;
			// 					background-color: #F4F3F3;
			// 					border-radius: 50%;
			// 				}
			// 				.tit_en{
			// 					font-size: 24px;
			// 				}
			// 				.tit{
			// 					padding: 15px 0 5px 0;
			// 					font-size: 30px;
			// 					font-weight: bold;
			// 				}
			// 				.bg{
			// 					width: 80px;
			// 					height: 80px;
			// 				}
			// 			}
			// 			img{
			// 				width: 100%;
			// 				height: 100%;
			// 				// height: 410px;
			// 				// height: 622px;
			// 				// object-fit: fill;
			// 			}
			// 		}
			// 		li:last-child{margin-right: 0;}
			// 		li:first-child{margin-left: 0;}
			// 	}
			// 	.current{
			// 		.small{display: none;}
			// 		.big{display: block;}
			// 	}
			// 	.small{position: absolute;display: block;}
			// 	.big{display: none;}
			// 	.active{width: 50%;}
			// }
			.top_box{
				display: flex;
				align-items: end;
				width: 80%;
				margin: 0 auto;
				padding: 100px 0 60px 0;
				.right{
					flex: 1;
					text-align: right;
					.line_box{
						div.actived{
							background-color: #C8000A;
						}
						div{
							display: inline-block;
							width: 80px;
							height: 2px;
							background-color: #E0E0E0;
						}
					}
				}
				.left{
					flex: 1;
				}
			}
		}
	}
	//块1
	.block_1{
		.block_1_main{
			.list_box{
				display: flex;
				min-width: 1560px;
				.right{
					flex: 1;
					display: flex;
					align-items: center;
					background-color: #F6F6F6;
					.right_main{
						width: 100%;
						padding: 0 150px;
						.txt{
							padding-top: 10px;
							font-size: 18px;
							line-height: 1.8;
						}
						.tit{
							padding-bottom: 20px;
							font-size: 36px;
							font-weight: bold;
							line-height: 1.6;
						}
					}
				}
				.left{
					flex: 1;
					img{
						width: 100%;
					}
				}
			}
			.top_box{
				display: flex;
				align-items: center;
				width: 80%;
				margin: 0 auto;
				padding: 60px 0;
				.right{
					flex: 1;
				}
				.left{
					flex: 1;
				}
			}
		}
	}
	//公共数字累加
	.num_box{
		margin-left: 150px;
		display: inline-block;
		position: relative;
		top: 10px;
		
		span{
			font-size: 60px;
			color: #C8000A;
		}
		.icon_2{
			position: absolute;
			right: -25px;
			bottom: 25px;
			font-size: 14px;
		}
		.icon_1{
			position: absolute;
			right: -25px;
			top: 18px;
			font-size: 24px;
		}
		.num{
			font-size: 100px;
			color: #C8000A;
			line-height: 1;
			span{
				font-size: 60px;
				color: #C8000A;
			}
		}
	}
	//公共标题
	.title_box{
		display: flex;
		align-items: end;
		.right_tit{
			width: auto;
			position: relative;
			top: -16px;
			margin-left: 30px;
			padding: 4px 0 0 20px;
			font-size: 18px;
			line-height: 1;
			border-left: 1px solid #333333;
		}
		.left_tit{
			width: auto;
			.tit_cn{
				font-size: 42px;
				font-weight: bold;
			}
			.tit_en{
				font-size: 36px;
				color: #B8B8B8;
			}
		}
	}
	//轮播
	.banner_box{
		min-width: 1200px;
		position: relative;
		.icon_left{
			left: 50px;
		}
		.icon_right{
			right: 50px;
		}
		.icon_left, .icon_right{
			position: absolute;
			z-index: 1;
			top: 50%;
			margin-top: -18px;
			background: #333333;
			border-radius: 50%;
			width: 36px;
			height: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
		}
		.swipe_box{
			.swiper_el{
				position: relative;
				img.bg{
					width: 100%;
				}
			}
		}
	}
}
</style>